const GET_NOTIFICATION_PROVIDERS_ING = 'NOTIFICATION/PROVIDER/GET_NOTIFICATION_PROVIDERS_ING'
const GET_NOTIFICATION_PROVIDERS_SUCCESS = 'NOTIFICATION/PROVIDER/GET_NOTIFICATION_PROVIDERS_SUCCESS'
const GET_NOTIFICATION_PROVIDERS_FAILURE = 'NOTIFICATION/PROVIDER/GET_NOTIFICATION_PROVIDERS_FAILURE'

const defaultState = {
  notificationProviders: []
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_PROVIDERS_SUCCESS:
      return {
        ...state,
        notificationProviders: action.payload
      }
    case GET_NOTIFICATION_PROVIDERS_ING:
    case GET_NOTIFICATION_PROVIDERS_FAILURE:
      return {
        ...state,
        notificationProviders: []
      }
    default:
      return {...state}
  }
}

export const getNotificationProviders = () => {
  return {
    types: [GET_NOTIFICATION_PROVIDERS_ING, GET_NOTIFICATION_PROVIDERS_SUCCESS, GET_NOTIFICATION_PROVIDERS_FAILURE],
    promise: (apiClient) => apiClient.get('/api/notifications/providers')
  }
}
